import { render, staticRenderFns } from "./latBro.vue?vue&type=template&id=37cd6a80&scoped=true"
import script from "./latBro.vue?vue&type=script&lang=js"
export * from "./latBro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cd6a80",
  null
  
)

export default component.exports